import {
  type LessonData,
  type LessonPlanModificationData,
} from './lesson-plan-modification.server'

export const getModificationDayNames = (
  modificationDays: LessonPlanModificationData['days'],
  sourceLesson: LessonData | undefined,
) => {
  if (!sourceLesson) {
    return modificationDays.join(',')
  }

  const dayNames: string[] = []
  modificationDays.forEach((dayId: string) => {
    const sourceDay = sourceLesson.days.find(srcDay => srcDay._id === dayId)
    if (sourceDay) {
      const dayStart = sourceDay.name.indexOf('Day')
      const dayLabel = sourceDay.name.substring(dayStart)
      dayNames.push(dayLabel)
    }
  })

  return dayNames.join(', ')
}
